import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Expo, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import { ch4_p09 } from "../../../layouts/ch4_p09/ch4_p09"

export class Chapter4Page9 extends AbstractStoryState {

    readonly bg = this.addChild(new SceneSprite());

    readonly phoneContainer = this.addChild(new PIXI.Container());

    readonly phone = this.phoneContainer.addChild(new SceneSprite());
    readonly notification = this.phoneContainer.addChild(new SceneSprite());
    readonly shine = this.phoneContainer.addChild(new SceneSprite());

    readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch4_p09/"));
    readonly frameRight = this.addChild(SceneSprite.withPrefix("ch4_p09/"));

    public init(pSize: PIXI.Point, pData: any) {
        // exported layouts from Animate CC
        ch4_p09.call(this);
        this.frameLeft.visible = false;
		this.frameRight.visible = false;

        // super.init calls onResize
        super.init(pSize, pData);
    }

    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
    }

    public animateIn(pOnComplete: () => void) {
        new TimelineLite()
            .from([this.bg], 1, {
                pixi: {
                    alpha: 0,
                }
            }, 0)
            // fade in frame after bg because of blend mode
            .from([this.frameLeft, this.frameRight], 2, {
                pixi: {
                    alpha: 0,
                }
            }, 1)
            .from(this.phoneContainer, 2, {
                pixi: {
                    y: this.phoneContainer.y + 500, // position in previous panel
                }, ease: Expo.easeOut
            }, 0)
            .call(()=>{
                super.animateIn(pOnComplete);
            })
        ;
    }

    public animateOut(pOnComplete: () => void) {
        super.animateOut(pOnComplete);
    }

    public onAnimateInComplete() {
        super.onAnimateInComplete();
        // interactivity
        this.phone.interactive = true;
        this.phone.buttonMode = true;
        this.phone.accessible = true;
        const dismissPhone = () => {
            this.gotoNextState({ transition: "left" });
        }
        this.phone.addListener(HLF.Input.Events.MOUSE_DOWN, dismissPhone);
        this.phone.addListener(HLF.Input.Events.TOUCH_MOVE, dismissPhone);
    }
}